<template>
  <section class="document" v-if="details">
    <div class="mt-2">
      <h3>
        <i class="fal fa-file-alt" />
        {{ details.document.name }} {{ details.documentVersion.version }}
      </h3>
    </div>
    <b-navbar toggleable="lg" class="submenu">
      <b-nav>
        <b-nav-item v-if="!loggedIn">

            <LocaleLogin></LocaleLogin>
       
        </b-nav-item>
        <b-nav-item :href="downloadUrl" v-if="canDownload" v-b-tooltip.hover :title="$t('DOCUMENT.DOWNLOAD_DOCUMENT')">
          <i class="fal fa-download" />
          <span>{{ $t('DOCUMENT.DOWNLOAD_DOCUMENT') }}</span>
        </b-nav-item>
        <b-nav-item
          href="#"
          @click="copyUrlClipBoard"
          v-b-tooltip.hover
          :title="$t('DOCUMENT.COPY_LINK')"
        >
          <i class="fal fa-external-link" />
          <span>{{ $t('DOCUMENT.COPY_LINK') }}</span>
        </b-nav-item>
        <b-nav-item
          href="#"
          @click="showModalVersions"
          v-b-tooltip.hover
          :title="$t('DOCUMENT.HISTORY')"
        >
          <i class="fal fa-history" />
          <span>{{ $t('DOCUMENT.HISTORY') }}</span>
        </b-nav-item>
        <b-nav-item href="#" @click="showModalHash" v-b-tooltip.hover :title="$t('DOCUMENT.HASH')">
          <i class="fal fa-hashtag" />
          <span>{{ $t('DOCUMENT.HASH') }}</span>
        </b-nav-item>
        <b-nav-item href="#" @click="showModalQR" v-b-tooltip.hover :title="$t('DOCUMENT.QRCODE')">
          <i class="fal fa-qrcode" />
          <span>{{ $t('DOCUMENT.QRCODE') }}</span>
        </b-nav-item>
      </b-nav>

      <b-nav class="ml-auto right" v-if="loggedIn">
        <span v-if="details.documentVersion.templateDocument == 0">
          <add-version
            v-if="details.document.teamId ===  user.team.id"
            @updatedDocumentVersion="updatedDocumentVersion"
            :item="details"
            :key="details.document.id"
          >
            <b-nav-item href="#" v-b-tooltip.hover :title="$t('DOCUMENT.ADD_NEW_VERSION')">
              <i class="fal fa-plus-circle" />
              <span>{{$t('DOCUMENT.ADD_NEW_VERSION')}}</span>
            </b-nav-item>
          </add-version>
        </span>

        <span v-if="details.documentVersion.templateDocument != 0">
          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <i class="fal fa-plus-circle" />
              <span>{{$t('DOCUMENT.ADD_NEW_VERSION')}}</span>
            </template>
            <b-dropdown-item
              :title="$t('DOCUMENT.ADD_NEW_VERSION')"
              :to="{ name: 'Template.Document', params: { documentId: details.documentVersion.templateDocument }}"
            >{{$t('DOCUMENT.ADD_NEW_VERSION_TEMPLATE')}}</b-dropdown-item>
            <add-version
              v-if="details.document.teamId ===  user.team.id"
              @updatedDocumentVersion="updatedDocumentVersion"
              :item="details"
              :key="details.document.id"
            >
              <b-dropdown-item
                href="#"
                v-b-tooltip.hover
                :title="$t('DOCUMENT.ADD_NEW_VERSION')"
              >{{$t('DOCUMENT.ADD_NEW_VERSION_FILE')}}</b-dropdown-item>
            </add-version>
          </b-nav-item-dropdown>
        </span>

        <select-document version="0" @selectedDocument="selectedDocument">
          <b-nav-item href="#" v-b-tooltip.hover :title="$t('DOCUMENT.ADD_NEW_REQUEST')">
            <i class="fa fa-link"></i>
            <span>{{ $t('DOCUMENT.ADD_NEW_REQUEST')}}</span>
          </b-nav-item>
        </select-document>
      </b-nav>
    </b-navbar>



    <div class="container-fluid">

      <b-alert
        show
        class="text-center"
        v-if="newVersions === 0"
      >{{ $t('DOCUMENT.THIS_IS_THE_LATEST_DOCUMENT') }}</b-alert>
      <b-alert variant="danger" show v-if="newVersions !== 0" class="mb-4 text-center">
        {{ $t('DOCUMENT.THIS_IS_NOT_THE_LATEST_DOCUMENT', {
        versions: newVersions }) }}
        <hr />
        <div class="text-center">
          <router-link
            :to="{ name: 'Document', params: { dclIdentity: details.document.publishedDclIdentity }}"
          >
            <i class="fal fa-file-alt" />
            {{$t('DOCUMENT.GOTO_LATEST_VERSION')}}
          </router-link>
        </div>
      </b-alert>
    </div>

    <div class="container-fluid mt-2">

      <b-card no-body>
        <b-tabs card>
          <b-tab :title="$t('VIEW')" active>
            <pdf :src="downloadUrl"></pdf>
          </b-tab>
            <b-tab :title="$t('DOCUMENT.INFORMATION')">

        <dl>
                      <dt>{{ $t('DOCUMENT.NAME') }}</dt>
                      <dd>{{ details.document.name }}</dd>
                      <dt>{{ $t('DOCUMENT.ID') }}</dt>
                      <dd>{{ details.documentVersion.dclIdentity }}</dd>
                      <dt>{{ $t('DOCUMENT.PUBLISHER') }}</dt>
                      <dd>{{ details.team }}</dd>
                      <dt v-if="template != null">{{ $t('TEMPLATE.TITLE') }}</dt>
                      <dd v-if="template != null">{{ template.templateDocument.name }} {{ template.templateDocumentVersion.version }}</dd>
                      <dt>{{ $t('DOCUMENT.VERSION') }}</dt>
                      <dd>{{ details.documentVersion.version }}</dd>
                      <dt>{{ $t('DOCUMENT.REPLACED') }}</dt>
                      <dd>{{ replacedBy }}</dd>
                      <dt>{{ $t('DOCUMENT.PUBLISHED') }}</dt>
                      <dd>{{ $moment(details.documentVersion.publishedDate) | moment("YYYY-MM-DD HH:mm") }}</dd>
                      <dt>{{ $t('DOWNLOADS') }}</dt>
                      <dd>{{ details.documentVersion.downloads }}</dd>
                      <dt>{{ $t('VIEWS') }}</dt>
                      <dd>{{ details.documentVersion.views }}</dd>
                      
                    </dl>

            </b-tab>
            <b-tab :title="$t('DOCUMENT.HIERARCHY')">

              
              <div :key="details.documentVersion.dclIdentity">
              </div>
              
              <div
                      class="text-center mb-2"
                      v-if="details.connections.childs.length == 0"
                    >{{ $t('DOCUMENT.NO_LINKED_DOCUMENTS') }}</div>

                    <ul class="tree" v-if="details.connections.childs.length != 0">
                      <li>
                        <hierarchy-item
                          :current="details.documentVersion.dclIdentity"
                          :item="details.connections"
                          :key="details.connections.dclIdentity"
                        />
                        <ul>
                          <tree-item
                            :current="details.documentVersion.dclIdentity"
                            v-for="nodeItem in details.connections.childs"
                            :node="nodeItem"
                            :key="nodeItem.dclIdentity"
                          />
                        </ul>
                      </li>
                    </ul>

                <select-document version="0" @selectedDocument="selectedDocument" v-if="loggedIn">
                        <b-btn href="#" v-b-tooltip.hover :title="$t('DOCUMENT.ADD_NEW_REQUEST')">
                          <i class="fal fa-link" />
                          {{$t('DOCUMENT.ADD_NEW_REQUEST')}}
                        </b-btn>
                      </select-document>
                  
              
              </b-tab>
          </b-tabs>
        </b-card>


    </div>

    <b-modal v-model="modalVersions" size="xl" centered no-fade hide-header>
      <div slot="modal-header" class="w-100">{{$t('DOCUMENT.HISTORY_MODAL_TITLE')}}</div>
      <div class="mt-2">
        <b-table
          hover
          :items="historyItems"
          :fields="historyFields"
          selectable
          select-mode="multi"
          @row-selected="setVersion"
        >
          <template
            v-slot:cell(publishedDate)="data"
          >{{ $moment(data.value) | moment("YYYY-MM-DD HH:mm") }}</template>
        </b-table>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn @click="hideModals">{{ $t('CLOSE')}}</b-btn>
      </div>
    </b-modal>

    <b-modal v-model="modalQR" size="xl" centered no-fade hide-header>
      <div slot="modal-header" class="w-100">{{$t('DOCUMENT.HISTORY_MODAL_TITLE')}}</div>
      <div class="mt-2 p-4 text-center">
        <img
          v-bind:src="'data:image/png;base64,'+image"
          style="height: 300px; border-radius: 5px; border: 1px solid #000;"
        />
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn @click="hideModals">{{ $t('CLOSE')}}</b-btn>
      </div>
    </b-modal>

    <b-modal v-model="modalHash" hide-header size="lg" centered no-fade>
      <div class="p-4">
        <dl>
          <dt>{{ $t('DOCUMENT.HASH_METHOD') }}</dt>
          <dd>{{details.documentVersion.hashMethod}}</dd>
          <dt>{{ $t('DOCUMENT.HASH') }}</dt>
          <dd>{{hash}}</dd>
        </dl>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn @click="hideModals">{{ $t('CLOSE')}}</b-btn>
      </div>
    </b-modal>
  </section>
</template>
<script>
import LocaleLogin from "@/components/Layout/LocaleLogin";
import pdf from '@/components/Pdf'
import TreeItem from "@/components/Ledger/TreeItem";
import HierarchyItem from "@/components/Ledger/HierarchyItem";
import AddVersion from "@/components/Ledger/AddVersion";
import SelectDocument from "@/components/Ledger/SelectDocument";
export default {
  props: ['dclIdentity'],
  components: {
    LocaleLogin,
    pdf,
    TreeItem,
    HierarchyItem,
    AddVersion,
    SelectDocument
  },
  data() {
    return {
      selected: 0,
      showDetails: false,
      modalVersions: false,
      modalQR: false,
      modalHash: false,
      newVersions: 0,
      details: null,
      template: null,
      publishedDetails: {},
      size: 250,
      image: "",
      bgColor: "#fff",
      fgColor: "#000",
      logo: "/img/qr-logo.png",
      historyItems: [],
      historyPage: 0,
      historyLimit: 25,
      historyCount: 0,
      historyFields: [
        {
          key: "version",
          label: this.$t("DOCUMENT.TABLE.VERSION"),
          sortable: false
        },
        {
          key: "publishedDate",
          label: this.$t("DOCUMENT.TABLE.PUBLISHED_DATE"),
          sortable: false
        },
        {
          key: "dclIdentity",
          label: this.$t("DOCUMENT.TABLE.DCLIDENTITY"),
          sortable: false
        }
      ],
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    updatedDocumentVersion: function(documentInformation) {
      this.details.documentVersion = documentInformation;
    },
    selectedDocument(dclIdentity) {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/document/request/apply", {
          dclIdentity: this.details.documentVersion.dclIdentity,
          AuditdclIdentity: dclIdentity
        })
        .then(function() {
          self.$noty.info(self.$t("DOCUMENT.SUCCESS.NEW_REQUEST"));
          this.hideModals();
        })
        .catch(function(error) {
          self.$noty.error(self.$t(error.response.data));
        });
    },
    showModalHash: function() {
      this.modalHash = true;
    },
    showModalQR: function() {
      this.modalQR = true;
    },
    showModalVersions: function() {
      this.getHistory();
      this.modalVersions = true;
    },
    hideModals: function() {
      this.modalVersions = false;
      this.modalQR = false;
      this.modalHash = false;
    },
    copyUrlClipBoard() {
      let self = this;
      this.$copyText(this.documentUrl).then(
        function() {
          self.$noty.info(self.$t("DOCUMENT.SUCCESS.COPIED_URL"));
        },
        function() {
          self.$noty.error(self.$t("DOCUMENT.ERROR.COULD_NOT_COPY_LINK"));
        }
      );
    },
    copyHash() {
      let self = this;
      this.$copyText(this.documentUrl).then(
        function() {
          self.$noty.info(self.$t("LEDGER.DETAILS.COPIED_HASH"));
        },
        function() {
          self.$noty.error(self.$t("LEDGER.ERROR.COULD_NOT_COPY_HASH"));
        }
      );
    },
    setVersion: function(item) {
      this.hideModals();
      if (item[0].dclIdentity != this.details.documentVersion.dclIdentity) {
        this.$router.push("/document/" + item[0].dclIdentity);
      }
    },
    getHistory: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/documents/history", {
          page: this.historyPage,
          limit: this.historyLimit,
          dclIdentity: this.details.document.dclIdentity
        })
        .then(response => {
          self.historyItems = response.data.items;
          self.historyCount = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    },
    getDocument: function() {
      
      let self = this;
      let isDocumentOnly = /^[A-Z\d]{4,}-[0-9A-Z\d]{4,}-[0-9A-Z\d]{4,}$/.test(this.dclIdentity);
      if(isDocumentOnly == true)
      {
        this.$http
        .get(process.env.VUE_APP_BACKEND + "/document/" + this.dclIdentity + "/current")
        .then(response => {
          self.$router.push("/document/" + response.data.dclIdentity);
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
      }else{
        this.$http
        .post(process.env.VUE_APP_BACKEND + "/document/information", {
          dclIdentity: this.dclIdentity
        })
        .then(response => {
          self.newVersions = response.data.newVersions;
          self.image = response.data.image;
          self.template = response.data.template;
          self.details = response.data.item;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
      } 
    }
  },
  computed: {
    downloadUrl() {
      return (
        process.env.VUE_APP_BACKEND +
        "/document/download/" +
        this.details.documentVersion.dclIdentity +
        ".pdf"
      );
    },
    hash() {
      return this.details.documentVersion.hash;
    },
    documentUrl() {
      return (
        process.env.VUE_APP_FRONTEND +
        "/document/" +
        this.details.documentVersion.dclIdentity
      );
    },
    canDownload() {
      if(this.details.document.public){
        return true;
      }else{
        if(this.loggedIn)
        {
          if(this.details.document.teamId == this.$store.state.auth.user.team.id)
          {
            return true;
          }
          return false;
        }else{
          return false;
        }
      }
    },
    loggedIn() {
      return this.$store.state.auth.user;
    },
    replacedBy() {
      if (this.details.documentVersion.replacedByDclIdentity === "") {
        return this.$t("DOCUMENT.THIS_IS_THE_FIRST_VERSION");
      }
      if (
        this.details.documentVersion.dclIdentity ===
        this.details.documentVersion.replacedByDclIdentity
      ) {
        return this.$t("DOCUMENT.THIS_IS_THE_LATEST_VERSION");
      }
      return this.details.documentVersion.replacedByDclIdentity;
    }
  },
  watch: {
    dclIdentity: function(){
      this.getDocument();
    }
  },
  mounted() {
    this.getDocument();
  }
};
</script>
<style>
</style>